// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"37072062","453":"6b8bed02","477":"ef477cad","768":"7c669c6c","873":"f8a7ff7f"}[chunkId] + ".chunk.js";
};